import React from 'react';
import {
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';

import styles from './Messages.module.css';

import Message from '../components/Message';

const Messages: React.FC = () => {
  const messages = Array.from([1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13]);
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Messages</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={styles.container}>
          <IonList>
            {messages.map(msg => {
              return <Message />;
            })}
          </IonList>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Messages;
